import React, { FC } from "react";
import { BeatLoader } from "react-spinners";

import logoImg from "assets/img/logo.jpg";
import Style from "./Style.module.scss";

const OverlayLoading: FC = () => {
  return (
    <div className={Style.overlay}>
      <div className="d-flex justify-content-center align-items-center">
        <div
          className={`bg-white d-flex flex-column justify-content-center align-items-center gap-4 ${Style.logoContainer} `}
        >
          <img src={logoImg} className={Style.logo} />
          <BeatLoader size={7} color="var(--primary)" className="mt-3" />
        </div>
      </div>
    </div>
  );
};

export { OverlayLoading };
